module.exports = __webpack_public_path__ + "static/Statesman-a8c97fac0848836c897e7f999f335cbe.png";